import { CheckmarkIcon3 } from "@/components/icons/CheckmarkIcon3";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

export interface SafetyBadgeProps {
  heading: string;
  text: string;
  onLightBg?: boolean;
  className?: string;
}

const SafetyBadge = ({ heading, text, onLightBg = false, className }: SafetyBadgeProps) => (
  <div
    className={cn(
      "flex items-center gap-2 rounded-[20px] shadow-[inset_4px_4px_4px_0_rgba(255,255,255,0.18)] backdrop-blur-[15px] p-2 md:py-2 md:px-4",
      onLightBg
        ? "bg-nova-transparency-black-10 border border-nova-transparency-black-20"
        : "bg-nova-transparency-white-20 border border-nova-transparency-white-20",
      className
    )}
  >
    <div className="p-[6px]">
      <div className="overflow-visible bg-nova-base-white rounded-full p-1 md:p-[6px]">
        <div className="overflow-visible bg-nova-base-solid-40 rounded-full md:p-[0.35rem]">
          <CheckmarkIcon3 className="h-[17px] md:h-[19px] w-[17px] md:w-[19px] shrink-0 overflow-visible text-nova-brand-primary-100" />
        </div>
      </div>
    </div>
    <div className="">
      <TextElementNova
        text={heading}
        className={cn("Body-20-Dia-Strong", !onLightBg && "text-nova-base-white")}
      />
      <TextElementNova
        text={text}
        className={cn("Caption-10-Dia-Normal", !onLightBg && "text-nova-base-white")}
      />
    </div>
  </div>
);

export default SafetyBadge;
